import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";

export default {
  state: {
    urlReset: null,
  },
  getters: {
    urlReset(state: any) {
      return state.urlReset;
    },
  },
  mutations: {
    setUrlReset(state: any, urlReset: any) {
      state.urlReset = urlReset;
    },
  },
  actions: {
    resetPassword({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        http
          .post("/api/v1/resetPassword/", payload)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getResetUrl({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        var param : any = payload;
        param = param.replaceAll("/", "%2F");
        http
          .get("/api/v1/resetPassword/getResetPassword/" + param)
          .then((result: any) => {
            commit("setUrlReset", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getUrlResetPassword({ commit }: { commit: any }, email: any) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/resetPassword/getUrlResetPassword/" + email)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
  },
};
